/**
 * Valor de face do produto em dinheiro, em reais.
 *
 * `cashValue` é a fonte da verdade. O fallback para `name` existe por causa dos
 * produtos legados, em que o nome do produto ERA o valor ("10", "10,50").
 * Retorna null quando não é resolvível.
 */
export function cashValueOf(product) {
    if (!product) { return null; }

    if (product.cashValue !== null && product.cashValue !== undefined && product.cashValue !== '') {
        const fromColumn = Number(product.cashValue);
        return Number.isFinite(fromColumn) ? fromColumn : null;
    }

    const legacyName = String(product.name === undefined || product.name === null ? '' : product.name).trim();
    if (legacyName === '') { return null; }

    const fromLegacyName = Number(legacyName.replace(',', '.'));
    return Number.isFinite(fromLegacyName) ? fromLegacyName : null;
}

/** Valor de face já formatado em moeda. String vazia quando não resolvível. */
export function formatCashValue(product) {
    const value = cashValueOf(product);
    return value === null ? '' : value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
}
